import { render, staticRenderFns } from "./CreatePortfolioDlg.vue?vue&type=template&id=a1456f64"
import script from "./CreatePortfolioDlg.vue?vue&type=script&lang=ts"
export * from "./CreatePortfolioDlg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports